<script setup lang="ts">
const { isMobile } = useDevice()
const title = 'Ketentuan Layanan - Kognisi.id'
const keywords =
  'ketentuan layanan, kebijakan penggunaan, syarat dan ketentuan, kognisi, hukum, peraturan situ'
const description =
  'Ketahui ketentuan layanan Kognisi.id  yang mengatur penggunaan situs, layanan, dan konten yang tersedia. Baca selengkapnya untuk memahami hak dan kewajiban Anda.'
const url = 'https://kognisi.id/ketentuan-layanan'

useHead({
  link: [{ rel: 'canonical', href: url }]
})
useSeoMeta({
  title,
  keywords,
  description,
  ogUrl: url,
  ogTitle: title,
  ogDescription: description,
  twitterTitle: title,
  twitterDescription: description,
  robots: 'index, follow'
})

const menus = ref<Record<string, any>[]>([
  {
    key: 'pembukaan_akun_anda',
    label: 'A. Pembukaan Akun Anda'
  },
  {
    key: 'informasi_pribadi_anda',
    label: 'B. Informasi Pribadi Anda'
  },
  {
    key: 'akses_terhadap_platform_kami',
    label: 'C. Akses terhadap Platform Kami'
  },
  {
    key: 'pembelian_dan_hak_akses_terhadap_kursus_daring_di_platform',
    label: 'D. Pembelian dan Hak Akses terhadap Kursus Daring di Platform'
  },
  {
    key: 'sertifikat',
    label: 'E. Sertifikat'
  },
  {
    key: 'ketentuan_pembayaran',
    label: 'F. Ketentuan Pembayaran'
  },
  {
    key: 'penggunaan_yang_dilarang',
    label: 'G. Penggunaan yang Dilarang'
  },
  {
    key: 'hak_kekayaan_intelektual',
    label: 'H. Hak Kekayaan Intelektual'
  },
  {
    key: 'pengunggahan_konten_pada_platform_kami',
    label: 'I. Pengunggahan Konten Pada Platform Kami'
  },
  {
    key: 'laporan_kemungkinan_pelanggaran',
    label: 'J. Laporan Kemungkinan Pelanggaran'
  },
  {
    key: 'tindakan_yang_kami_anggap_perlu',
    label: 'K. Tindakan yang Kami Anggap Perlu'
  },
  {
    key: 'membuat_tautan_ke_platform_kami',
    label: 'L. Membuat Tautan ke Platform Kami'
  },
  {
    key: 'tautan_pihak_ketiga_pada_platform_kami',
    label: 'M. Tautan Pihak Ketiga Pada Platform Kami'
  },
  {
    key: 'tanggung_jawab_anda',
    label: 'N. Tanggung Jawab Anda'
  },
  {
    key: 'batasan_tanggung_jawab_kami',
    label: 'O. Batasan Tanggung Jawab Kami '
  },
  {
    key: 'keadaan_kahar',
    label: 'P. Keadaan Kahar (Force Majeure)'
  },
  {
    key: 'hukum_yang_berlaku',
    label: 'Q. Hukum yang Berlaku'
  },
  {
    key: 'ketentuan_lainnya',
    label: 'R. Ketentuan Lainnya'
  }
])
</script>

<template>
  <div id="ketentuan-layanan">
    <NuxtLayout name="static-page">
      <NuxtLoadingIndicator />
      <LazyModulesStaticPageAtomsSidebar v-if="!isMobile" :menus="menus" />
      <LazyModulesStaticPageMoleculesKetentuanLayananContent />
    </NuxtLayout>
  </div>
</template>
